import { render, staticRenderFns } from "./ZineMachinesPage.vue?vue&type=template&id=0af4740c&scoped=true&"
import script from "./ZineMachinesPage.vue?vue&type=script&lang=js&"
export * from "./ZineMachinesPage.vue?vue&type=script&lang=js&"
import style0 from "./ZineMachinesPage.vue?vue&type=style&index=0&id=0af4740c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4740c",
  null
  
)

export default component.exports